export default __webpack_public_path__ + "static/media/loading-gif.83a3fdcb.webp";